import { z } from 'zod'

// ─── Master Contract Types ───────────────────────────────────────────────────

export const masterContractTypeCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	sortOrder: z.number().int().default(0).optional(),
})

export const masterContractTypeUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type MasterContractTypeCreateInput = z.infer<typeof masterContractTypeCreateSchema>
export type MasterContractTypeUpdateInput = z.infer<typeof masterContractTypeUpdateSchema>

// ─── Master Geo Locations ────────────────────────────────────────────────────

export const masterGeoLocationCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	countryCode: z.string().length(2, 'Country code must be 2 characters (ISO 3166-1 alpha-2)').optional(),
	sortOrder: z.number().int().default(0).optional(),
})

export const masterGeoLocationUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	countryCode: z.string().length(2, 'Country code must be 2 characters (ISO 3166-1 alpha-2)').optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type MasterGeoLocationCreateInput = z.infer<typeof masterGeoLocationCreateSchema>
export type MasterGeoLocationUpdateInput = z.infer<typeof masterGeoLocationUpdateSchema>

// ─── Master Departments ──────────────────────────────────────────────────────

export const masterDepartmentCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	parentId: z.uuid().nullable().optional(),
	sortOrder: z.number().int().default(0).optional(),
})

export const masterDepartmentUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	parentId: z.uuid().nullable().optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type MasterDepartmentCreateInput = z.infer<typeof masterDepartmentCreateSchema>
export type MasterDepartmentUpdateInput = z.infer<typeof masterDepartmentUpdateSchema>

// ─── Environments ────────────────────────────────────────────────────────────

export const environmentCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	sortOrder: z.number().int().default(0).optional(),
})

export const environmentUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type EnvironmentCreateInput = z.infer<typeof environmentCreateSchema>
export type EnvironmentUpdateInput = z.infer<typeof environmentUpdateSchema>

// ─── Cloud Providers ─────────────────────────────────────────────────────────

export const cloudProviderCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	sortOrder: z.number().int().default(0).optional(),
})

export const cloudProviderUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type CloudProviderCreateInput = z.infer<typeof cloudProviderCreateSchema>
export type CloudProviderUpdateInput = z.infer<typeof cloudProviderUpdateSchema>

// ─── Master Leadership Types ────────────────────────────────────────────────

export const masterLeadershipTypeCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	sortOrder: z.number().int().default(0).optional(),
})

export const masterLeadershipTypeUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type MasterLeadershipTypeCreateInput = z.infer<typeof masterLeadershipTypeCreateSchema>
export type MasterLeadershipTypeUpdateInput = z.infer<typeof masterLeadershipTypeUpdateSchema>

// ─── Master Person Types ────────────────────────────────────────────────────

export const masterPersonTypeCreateSchema = z.object({
	code: z.string().min(1, 'Code is required'),
	label: z.string().min(1, 'Label is required'),
	sortOrder: z.number().int().default(0).optional(),
})

export const masterPersonTypeUpdateSchema = z.object({
	label: z.string().min(1).optional(),
	isActive: z.boolean().optional(),
	sortOrder: z.number().int().optional(),
})

export type MasterPersonTypeCreateInput = z.infer<typeof masterPersonTypeCreateSchema>
export type MasterPersonTypeUpdateInput = z.infer<typeof masterPersonTypeUpdateSchema>
